import React, {
  PropTypes,
} from 'react';
import './Footer.scss';
import { Link } from 'react-router-dom';

function Footer() {
  const currentDate = new Date();
  return (
    <div className="footer row medium-unstack collapse small-unstack">
      <div className="shrink columns">
        <div className="footer__text footer__left-column">
          <ul>
            <li>
              <Link className="link" to="/information">
              Сведения об автошколе
              </Link>
            </li>
            <li>
              <a
                target="_blank"
                href="https://edu.gov.ru/"
                className="link"
                rel="noopener noreferrer"
              >
                Министерство просвещения Российской Федерации
              </a>
            </li>
            <li>
                © 2008–{currentDate.getFullYear()} ЧУ ДПО «Дизель»
            </li>
          </ul>
        </div>
        </div>
      <div className="shrink columns">
        <div className="footer__text footer__right-column">
          <div>г. Пермь, ул. М. Горького, 21</div>
          <div>тел. +7 (951) 938-40-29</div>
          <div>
            <a
              href="mailto:dieselperm@gmail.com?subject=Автошкола"
              className="link"
            >
              dieselperm@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

Footer.propTypes = {};
Footer.defaultProps = {};

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx